import {
  GET_RECORDS,
  GET_RECORDS_SUCCESS,
  GET_RECORDS_ERROR,
  GET_GA_RECORDS,
  GET_GA_RECORDS_SUCCESS,
  GET_GA_RECORDS_ERROR,
  GET_DROPDOWN_SEARCH_LIST,
  GET_DROPDOWN_SEARCH_LIST_SUCCESS,
  UPDATE_SELECTED_RECORDS,
  UPDATE_FILTER,
  UPDATE_RECORD_LISTING_STATE,
  GET_CHILD_RECORDS,
  GET_CHILD_RECORDS_SUCCESS,
  GET_CHILD_RECORDS_ERROR
} from "../actions";
import EnumRecordTypes from "../../enums/enumRecordTypes";

const INIT_STATE = {
  selectedRecordType: EnumRecordTypes.Person,
  searchRecordType: EnumRecordTypes.Person,
  searchResult: [],
  searchResultEmpty: [],
  selectedFilters: {},
  loading: false,
  profile: null,
  params: null,
  verbType: 2,
  error: "",
  recordList: {
    records: null,
    pagination: {
      pageNumber: 1,
      pageSize: 5,
      startIndex: 1,
      totalItemCount: 0,
      totalPages: 0,
    },
    selectedRecords: {},
    responseTime: null
  },
  recordGAList: {
    gaRecords: [],
    pagination: {
      pageNumber: 1,
      pageSize: 5,
      startIndex: 1,
      totalItemCount: 0,
      totalPages: 0,
    },
    selectedRecords: {},
    responseTime: null
  },
};

const getRecordType = (recordTypeString) => {
  let recordTypeValue = EnumRecordTypes.Person;
  for (const key in EnumRecordTypes) {
    if (key.toLowerCase() === recordTypeString.toLowerCase()) {
      recordTypeValue = EnumRecordTypes[key];
      break;
    }
  }
  return recordTypeValue;
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DROPDOWN_SEARCH_LIST:
      return {
        ...state,
        searchResult: [],
        searchRecordType: action.payload.searchRecordType,
        searchText: action.payload.searchText,
      };
    case GET_DROPDOWN_SEARCH_LIST_SUCCESS:
      return { ...state, searchResult: action.payload };
    case GET_CHILD_RECORDS:
      return { ...state, isChildRecordsLoading: true, childRecordsGetError: "" };
    case GET_CHILD_RECORDS_SUCCESS:
      let updatedParentChildRecords = state.parentChildRecords ? [...state.parentChildRecords] : [];
      let recordIndex = updatedParentChildRecords.findIndex(pcr => pcr.parentRecordGuid === state.selectedParentRecordGuid);
      const childRecords = action.payload && action.payload.records && action.payload.records.data ? action.payload.records.data.items : [];
      if (recordIndex > -1) {
        updatedParentChildRecords[recordIndex] = { parentRecordGuid: state.selectedParentRecordGuid, childRecords: childRecords };
      } else {
        updatedParentChildRecords.push({ parentRecordGuid: state.selectedParentRecordGuid, childRecords: childRecords });
      }
      return { ...state, isChildRecordsLoading: false, childRecordsGetError: "", parentChildRecords: updatedParentChildRecords };
    case GET_CHILD_RECORDS_ERROR:
      return { ...state, isChildRecordsLoading: false, childRecordsGetError: action.payload.message };
    case GET_RECORDS:
      return {
        ...state,
        loading: true,
        error: "",
        recordList: null,
        selectedRecordType:
          typeof action.payload.recordType === "string"
            ? getRecordType(action.payload.recordType)
            : action.payload.recordType,
        displayStatus: action.payload.displayStatus,
        pageNumber: action.payload.pageNumber,
        parentRecordId: action.payload.parentRecordId,
        selectedFilters: action.payload.selectedFilters,
        vocabularyId: action.payload.vocabularyId,
        profile: action.payload.profile,
        params: action.payload.params,
        verbType: action.payload.verbType,
        hasUserAccount: action.payload.hasUserAccount ? action.payload.hasUserAccount : "",
        isSagaExecuted: true,
      };
    case GET_RECORDS_SUCCESS:
      return { ...state, loading: false, error: "", recordList: action.payload, isSagaExecuted: false };
    case GET_RECORDS_ERROR:
      const recordList = { ...state.recordList, records: [] };
      recordList.pagination = {
        ...recordList.pagination,
        totalItemCount: 0,
        totalPages: 0,
        isSagaExecuted: false,
      };
      return { ...state, loading: false, error: action.payload.message, recordList };
    case GET_GA_RECORDS:
      return {
        ...state,
        loading: true,
        error: "",
        recordGAList: null,
        pageNumber: action.payload.pageNumber,
      };
    case GET_GA_RECORDS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        recordGAList: action.payload,
      };
    case GET_GA_RECORDS_ERROR:
      const recordGAList = { ...state.recordGAList, records: [] };
      recordGAList.pagination = {
        ...recordGAList.pagination,
        totalItemCount: 0,
        totalPages: 0,
      };
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        recordGAList,
      };
    case UPDATE_SELECTED_RECORDS:
      const newRecordList = {};
      action.payload.recordList.forEach((item) => {
        newRecordList[item.selectedRecordId] = item.isChecked;
        if (item.selectedRecordId === -999 && item.isChecked) {
          return { "-999": true };
        }
      });
      const updatedRecords = { ...state.selectedRecords, ...newRecordList };
      return { ...state, selectedRecords: updatedRecords };
    case UPDATE_FILTER:
      const newFilterList = { ...state.selectedFilters, ...action.payload.filter };
      return { ...state, selectedFilters: newFilterList };
    case UPDATE_RECORD_LISTING_STATE:
      return { ...state, ...action.payload };
    default:
      return { ...state };
  }
};
